var map = {
	"./icon_chuangxin@2x.png": "1f91",
	"./icon_hutong@2x.png": "4108",
	"./icon_jianrong@2x.png": "ddf8",
	"./icon_jicheng@2x.png": "90e8",
	"./icon_jieshao@2x.png": "740b",
	"./icon_kexin@2x.png": "c079"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "971d";